import { render } from "./EventOwner.vue?vue&type=template&id=7817a63e"
import script from "./EventOwner.vue?vue&type=script&lang=js"
export * from "./EventOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__